








































































import { Inject } from '@cds/common';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';

@Component({
  components: {
  }
})
export default class buddyAIStatisticsNew extends Vue {
  [x: string]: any;
  public form: any = {
    pages: 1, 
    size: 10, 
    current: 1, 
    total: 0, 
    employeeId: '', 
    email: '',
    type: '',
  };

  public datacreateTime: any[] = [];
  private tableData: any[] = [];
  public loading: Boolean = false;
  
  public typeList: any[] = [
    { id: 0, name: '查看任务' },
    { id: 1, name: '查看公司服务热线详情' },
    { id: 2, name: '阅读新手须知' },
    { id: 3, name: '提交反馈' },
    { id: 4, name: '取消收藏文章' },
    { id: 5, name: '完成任务' },
    { id: 7, name: 'AI搜索' },
    { id: 8, name: '查看KPI' },
    { id: 9, name: '前往诺华视界看视频' },
    { id: 10, name: '登录' },
    { id: 11, name: '收藏文章' },
    { id: 12, name: '前往外链: Windows密码重置页面' },
    { id: 13, name: '查看文章' },
    { id: 14, name: '文章进入AI' },
    { id: 15, name: '进入AI首页' },
    { id: 16, name: 'tabbar进入AI' },
    { id: 17, name: '进入AI输入页' },
    { id: 18, name: '查看反馈历史页面' },
    { id: 19, name: '查看收藏列表页面' },
    { id: 20, name: '前往外链' },
    { id: 21, name: '点踩文章' },
    { id: 22, name: '取消点踩文章' },
    { id: 23, name: '查看一线KPI内容' },
    { id: 24, name: '查看反馈详情' },
    { id: 25, name: '继续阅读' },
    { id: 26, name: '查看阅读历史页面' },
    { id: 27, name: '拨打服务热线' },
    { id: 28, name: '任务进入AI' },
    { id: 29, name: '查看餐厅查询页面' }
  ];
  
  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;
  
  public async created(): Promise<void> {
    await this.getList();
  }
  
  //获取数据源
  public async getList() {
    var that = this;
    that.loading = true;
    
    let params = this.buildQueryParams();
    
    try {
      const res = await this.nuoxiaoerService.fetchUserActionLog(params);
      if (res) {
        that.tableData = res.records || [];
        this.form.total = res.total || 0;
        this.form.pages = res.pages || 0;
        this.form.size = res.size || 10;
        this.form.current = res.current || 1;
      }
    } catch (error) {
      console.error("获取数据失败", error);
      this.$message.error("获取数据失败");
    } finally {
      that.loading = false;
    }
  }
  
  // 构建查询参数
  private buildQueryParams() {
    let params = {
      employeeId: this.form.employeeId.toString(),
      employeeEmail: this.form.email,
      type: this.form.type,
      current: this.form.current,
      size: this.form.size
    };
    
    if (this.datacreateTime && this.datacreateTime.length > 0) {
      params['createDateStart'] = this.datacreateTime[0];
      params['createDateEnd'] = this.datacreateTime[1];
    }
    
    return params;
  }

  //导出
  public async exportClick(): Promise<void> {
    if (this.tableData.length <= 0) {
      this.$message({
        type: 'error',
        message: '当前无下载内容！'
      });
      return;
    }
    
    let params = this.buildQueryParams();
    
    // 生成当前日期作为文件名
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const timeSend = year + '-' + month + '-' + day;
    
    try {
      this.loading = true;
      await this.nuoxiaoerService.exportUserActionLogToExcel(params, '诺小二AI用户行为日志' + timeSend);
    } catch (error) {
      console.error("导出失败", error);
      this.$message.error("导出失败");
    } finally {
      this.loading = false;
    }
  }
  
  public search() {
    this.form.current = 1;
    this.getList();
  }
  
  // 重置
  public reset() {
    this.form = {
      size: this.form.size, 
      current: 1,
      employeeId: '', 
      email: '', 
      type: '',
      total: this.form.total,
      pages: this.form.pages
    };
    this.datacreateTime = [];
    this.getList();
  }
  
  //分页相关
  public handleSizeChange(size: number) {
    this.form.size = size;
    this.getList();
  }
  
  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getList();
  }
  
  private mounted() {
    document.onkeydown = (e) => {
      let key = (window.event as any).keyCode;
      if (key == 13) {
        this.search()
      }
    }
  }

  private handleTypeClear() {
    this.form.type = '';
  }
}
